// extracted by mini-css-extract-plugin
module.exports = {"slider":"_nx","lightBg":"_ny","sliderLink":"_nz","sliderTitle":"_nA","sliderTitleSelected":"_nB","centerMenu":"_nC"};